import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const AuthGuard = ({ children, requiredRoles }) => {
  const { user, role, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      if (!user) {
        // Se l'utente non è loggato, rispediscilo al login
        navigate('/login', { replace: true });
      } else if (requiredRoles && !requiredRoles.includes(role)) {
        // Se è loggato ma non ha il ruolo giusto, rimandalo alla pagina clienti
        navigate('/clienti', { replace: true });
      }
    }
  }, [user, role, loading, navigate, requiredRoles]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!user || (requiredRoles && !requiredRoles.includes(role))) return null;
  return children;
};

export default AuthGuard;